import * as React from 'react';

import { IDriverset } from '../api/models';
import { startDayFor } from '../types/IArea';
import { AquaFishFacade, IAquaFishResult } from '../c/AquaFishFacade';
import { GrowthChart } from './GrowthChart';
import type { ISeriesConfig } from './types';

interface IProps {
  driverset: IDriverset | null;
  days: number;
  /** Month the culture period starts in; unset means January. */
  startMonth?: number | null;
  /** AquaFish model code; unset runs the Atlantic salmon default. */
  species?: number;
  /** Starting weight in g; unset leaves the facade on its own default. */
  initialWeight?: number;
}

const AquaFishChart = (props: IProps) => {
  const [chart, setChart] = React.useState<IAquaFishResult | null>(null);

  React.useEffect(() => {
    if (props.driverset != null) {
      AquaFishFacade.call(
        { startTime: startDayFor(props.startMonth), endTime: props.days - 1, species: props.species, initialWeight: props.initialWeight },
        props.driverset)
        .then(res => setChart(res));
    }
  }, [props.driverset, props.days, props.startMonth, props.species, props.initialWeight]);

  const getSeries = (): ISeriesConfig[] => {
    if (!chart) return [];

    return [
      {
        label: 'Weight',
        color: '#E63946',
        data: chart.days.map(d => ({ x: d.modelTime, y: d.individualWeight })),
        axis: { position: 'left', title: 'Weight', min: 0, width: 60 },
        tooltipDecimals: 0,
        unit: 'g'
      },
      {
        label: 'Length',
        color: '#0D9488',
        data: chart.days.map(d => ({ x: d.modelTime, y: d.individualLength })),
        axis: { position: 'right', title: 'Length', min: 0, width: 42 },
        tooltipDecimals: 0,
        unit: 'cm'
      },
      {
        label: 'FCR',
        color: '#7C3AED',
        data: chart.days.map(d => ({ x: d.modelTime, y: d.FCR })),
        axis: { position: 'right', title: 'FCR', min: 0, max: 2, width: 44 },
        hideBeforeDay: 10,
        tooltipDecimals: 2
      }
    ];
  };

  return (
    <GrowthChart
      days={props.days}
      series={getSeries()}
    />
  );
}

export { AquaFishChart }
